import React from 'react'

const Footer = () => {
  return (
    <div className="col">
      <div className="col-4">
        <img src="Tafe.png" alt="Tafe Logo" className="logo-f" />
        <p className="footer-1">About Us</p>
        <p className="footer-2">Our Heritage</p>
        <p className="footer-2">Tea House</p>
        <p className="footer-2">Our Company</p>
        <p className="footer-1">Contact</p>
        <p className="footer-2">Kumbakonam-612001</p>
        <p className="footer-2">info@tafe.com</p>
        <p className="footer-2">+91 7604 923 423</p>
        <p className="footer-1">Quick Links</p>
        <p className="footer-2">Privacy policy</p>
        <p className="footer-2">Careers</p>
        <p className="footer-2">FAQs</p>

      </div>
      <hr/>
      <p className="footer">  About Us  |  Contact  |  Terms of Conditions | 2024 @ Tafe Tea Company.  All Rights Reserved.</p>
    </div>
  )
}

export default Footer